
"use client";

import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { motion, Variants, AnimatePresence } from 'framer-motion';
import { Mail, Send, ShoppingCart, ArrowRight } from "lucide-react";
import { Truck, Headphones, RotateCcw } from "lucide-react"

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import blogData from "@/public/ecomsaas-assets/cache/blogs.json";

import Image from "next/image";
import { addtowishlist } from "@/clicks/wishlistClicks";
import { axiosGetWishlist } from "@/utilities/axioscall";
import { useRouter } from "next/navigation";
import Link from "next/link";
import dynamic from "next/dynamic";
import SvgIcons from "../themes/SvgIcons";
import type { Swiper as SwiperType } from "swiper";
// import MobileVideoReelSlider from "../themes/MobileVideoReelSlider";

const Homepage = ({
  categoryListData,
  featuredcategoriesListData,
  bestsellersListData,
  topratedListData,
}: {
  categoryListData: any;
  featuredcategoriesListData: any;
  bestsellersListData: any;
  topratedListData: any;
}) => {
  console.log(categoryListData, 'categoryListData')
  const [pageinit, setPageInit] = useState(false);
  const [count, setCount] = useState<number>(1);
  const [productwishlistData, setproductwishlistData] = useState<any[]>([]);
  const router = useRouter();
  const navigate = (moveon: string) => {
    router.push(moveon);
  };
  const [activeCategory, setActiveCategory] = useState(0);
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);


  const categories = [

    {
      id: 1,
      name: "Milkshakes Core Equipments",
      price: "₹4500.00",
      originalPrice: "₹6000.00",
      discount: "-25%",
      image: "https://assetsvilva.blr1.cdn.digitaloceanspaces.com/MY0352EH2711/uploads/vQQi56pBPmx5yIvSNveC5sTZ7eJ0MqRpFU89Cr8l.webp",
    },
    {
      id: 2,
      name: "Chaats Core Equipment",
      price: "₹3200.00",
      originalPrice: "₹4500.00",
      discount: "-30%",
      image: "https://assetsvilva.blr1.cdn.digitaloceanspaces.com/MY0352EH2711/uploads/G1BSmgca4oioKNmGF4TdiilI6cUdGWgBo3EVs45B.webp",
    },
    {
      id: 3,
      name: "Waffles Core Equipments",
      price: "₹5500.00",
      originalPrice: "₹7500.00",
      discount: "-27%",
      image: "https://assetsvilva.blr1.cdn.digitaloceanspaces.com/MY0352EH2711/uploads/9sQpaZwIWqC07tVpJE9X6lB0tayHD5lOPZzGftFi.webp",
    },
    {
      id: 4,
      name: "Sandwich,Wraps Core Equipments",
      price: "₹2800.00",
      originalPrice: "₹4000.00",
      discount: "-30%",
      image: "https://assetsvilva.blr1.cdn.digitaloceanspaces.com/MY0352EH2711/uploads/OfWs0Yr5v0HjpISkPnsZY8R0hpERSw1gufKerTHi.webp",
    },

  ]

  const scrollVariants: Variants = {
    initial: { x: 0 },
    animate: {
      x: -1000,
      transition: {
        x: {
          repeat: Infinity,
          repeatType: 'loop',
          duration: 20,
          ease: 'linear',
        },
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  };

  const textVariants: Variants = {
    initial: { opacity: 0, y: 20 },
    animate: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: 'easeOut',
      },
    },
  };

  const [isMobile, setIsMobile] = useState(false);



  useEffect(() => {
    if (!pageinit) {
      setPageInit(true);
      axiosGetWishlist(setproductwishlistData);
    }

    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width < 768);
      if (width < 400) setCharLimit(20);
      else if (width < 640) setCharLimit(25);
      else if (width < 768) setCharLimit(30);
      else if (width < 1024) setCharLimit(40);
      else setCharLimit(50);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [pageinit]);

  const [charLimit, setCharLimit] = useState(40);

  const allowedCategoryIds = [18, 19, 20, 21, 754];

  const dummyCategories = [
    {
      id: 9001,
      name: "+combo",
      seo_url: "combo",
      banner: "https://assetsvilva.blr1.cdn.digitaloceanspaces.com/tamiltshirts/uploads/dETgxevoyOxbTIfsMHRu3eO6AzFtUcieQ6DTVJjy.webp",
      sortorder: 0,
      display_in_menu: 1,
    },
    {
      id: 9002,
      name: "Custom Order",
      seo_url: "custom-order",
      banner: "https://assetsvilva.blr1.cdn.digitaloceanspaces.com/tamiltshirts/uploads/pvaKBOApu3cLaKHSWrtqQ3nAFXHOu5ermT5aagMt.webp",
      sortorder: 1,
      display_in_menu: 1,
    },
    {
      id: 9003,
      name: "Offers",
      seo_url: "offers",
      banner: "https://assetsvilva.blr1.cdn.digitaloceanspaces.com/tamiltshirts/uploads/SwiWyxab4ss8457frHyixyWIAupllCPw4LVL2QKQ.webp",
      sortorder: 2,
      display_in_menu: 1,
    },
  ];

  const realCategories = categoryListData
    ?.filter((category: any) =>
      allowedCategoryIds.includes(category.id) &&
      category.display_in_menu === 1
    )
    .sort((a: any, b: any) => a.sortorder - b.sortorder);

  const mainCategories = [...(realCategories || []), ...dummyCategories].sort(
    (a, b) => a.sortorder - b.sortorder
  );

  if (!mainCategories || mainCategories.length === 0) {
    return <div className="text-center py-4">No categories available</div>;
  }

  console.log(mainCategories, "mainCategorieslist")

  const [currentIndex, setCurrentIndex] = useState(0);
  const [swiperRef, setSwiperRef] = useState<SwiperType | null>(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % 2);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  const [isFirst, setIsFirst] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsFirst((prev) => !prev);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    setEmail("");
    setTimeout(() => setSubmitted(false), 3000);
  };

  // Animation variants for new sections
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  const itemVariants: Variants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  const imageVariants: Variants = {
    hidden: { opacity: 0, x: 50 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  const highlights = [
    {
      icon: Truck,
      title: "Free Shipping",
      description: "On orders over ₹50",
    },
    {
      icon: Headphones,
      title: "24/7 Support",
      description: "Dedicated customer service",
    },
    {
      icon: RotateCcw,
      title: "Money Back Guarantee",
      description: "30 days to return",
    },
  ]


  const products = [
    {
      id: 1,
      name: "Sujatha Mixer Grinder",
      price: "₹405.00",
      originalPrice: "₹600.00",
      discount: "-25%",
      image: "https://assetsvilva.blr1.cdn.digitaloceanspaces.com/MY0352EH2711/uploads/x4cqZ3TkcW9F3CY0EY9okZvTGLpuxyqSeGyvMmxF.webp",
    },
    {
      id: 2,
      name: "Pradeep Boiler",
      price: "₹302.00",
      originalPrice: "₹405.00",
      discount: "-30%",
      image: "https://assetsvilva.blr1.cdn.digitaloceanspaces.com/MY0352EH2711/uploads/I9YfgScgKZ0edyhqP8DMZNAAGUqwEPnVtInTqHDc.webp",
    },
    {
      id: 3,
      name: "Bain Marie",
      price: "₹550.00",
      originalPrice: "₹750.00",
      discount: "-27%",
      image: "https://assetsvilva.blr1.cdn.digitaloceanspaces.com/MY0352EH2711/uploads/DXO9dYLMdgKvBLZKi1yes45uJob5sJ00koEzwZFA.webp",
    },
    {
      id: 4,
      name: "Dabara Set",
      price: "₹28.00",
      originalPrice: "₹40.00",
      discount: "-30%",
      image: "https://assetsvilva.blr1.cdn.digitaloceanspaces.com/MY0352EH2711/uploads/TpDlUsswdLteG7yX5REUsKpMdQT9wJuNZRMkEKRh.webp",
    },
    {
      id: 5,
      name: "Coffee Machine",
      price: "₹250.00",
      originalPrice: "₹350.00",
      discount: "-29%",
      image: "https://assetsvilva.blr1.cdn.digitaloceanspaces.com/MY0352EH2711/uploads/dtEBvFQQ35KmTvdXfwcXgasO4ABVTZZjq4176BTi.webp",
    },
    {
      id: 6,
      name: "Container",
      price: "₹380.00",
      originalPrice: "₹520.00",
      discount: "-27%",
      image: "https://assetsvilva.blr1.cdn.digitaloceanspaces.com/MY0352EH2711/uploads/xlv8GTIaalRM6PLRGfkoeICftGnCs8HO3vpp17HN.webp",
    },
  ]

  const blogs = [
    {
      id: 1,
      title: "How to Set Up a Tea Shop From Scratch",
      excerpt:
        "A complete step-by-step guide to starting your own tea café — from choosing the right equipment to planning layout, menu, and customer experience.",
      image: "https://assetsvilva.blr1.cdn.digitaloceanspaces.com/MY0352EH2711/uploads/eeiJNrG4S6HYUJUb3Lu6mNabFfusBsHMKGmpRT2r.webp",
      date: "March 15, 2024",
    },
    {
      id: 2,
      title: "Essential Tea Brewing Equipment Every Café Needs",
      excerpt:
        "Discover the most important tools for professional tea preparation, including kettles, boilers, tea brewers, and premium serving containers.",
      image: "https://assetsvilva.blr1.cdn.digitaloceanspaces.com/MY0352EH2711/uploads/VecBA4VNAgxHc1DKc74nnArgidtXVPkmzgQDwjBK.webp",
      date: "March 12, 2024",
    },
    {
      id: 3,
      title: "How to Increase Tea Shop Sales With Smart Display Counters",
      excerpt:
        "Learn how display counters, storage jars, and organized bar setups can boost customer appeal and improve order efficiency in cafés.",
      image: "https://assetsvilva.blr1.cdn.digitaloceanspaces.com/MY0352EH2711/uploads/QS9Rdv5aXDAaY9IlkqPFJ5juwPwwT9BKCWK9GC5m.webp",
      date: "March 10, 2024",
    },
  ];





  return (



    <>
      <div className="overflow-hidden">


        {/* Hero Banner - NEW HERO SECTION */}
        <section className=" bg-white pt-12 pb-12 md:pt-24 md:pb-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
              {/* Left Content */}
              <motion.div
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                className="space-y-6"
              >
                <motion.h1 variants={itemVariants} className="text-5xl md:text-[50px] font-bold text-gray-900 leading-tight">

                  Setup & Equipment That Help Your Tea Shop Scale
                </motion.h1>

                <motion.div variants={itemVariants} className="w-[200px] h-1 bg-gradient-to-r from-primary to-white" />

                <motion.p variants={itemVariants} className="text-gray-600 text-base md:text-lg leading-relaxed max-w-md">
                  Build your dream tea café with high-quality equipment designed for efficiency, performance, and style.
                  Explore our curated range of tea brewers, storage containers, display counters, cup dispensers,
                  barista tools, and full shop setup solutions — everything you need to start, upgrade, or expand your tea business.
                </motion.p>


                <motion.div variants={itemVariants} className="pt-4">
                  <Link
                    href="#"
                    className="inline-block bg-primary text-white px-8 py-3 rounded-sm font-medium hover:bg-primary_hover transition-colors duration-300"
                  >
                    Shop Collection →
                  </Link>
                </motion.div>
              </motion.div>

              {/* Right Image */}
              <motion.div
                variants={imageVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                className="relative h-[500px]"
              >
                <img
                  src="https://assetsvilva.blr1.cdn.digitaloceanspaces.com/MY0352EH2711/uploads/rG8cftCSZALuXZHHrbeWxdxMnx8Z5ZteQQZMbrXd.webp"
                  alt="Premium plant collection"
                  className="w-full h-full object-cover rounded-lg shadow-lg"
                />
              </motion.div>
            </div>
          </div>
        </section>



        <section className="py-16 md:py-[40px] bg-white border-y border-gray-100">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <motion.div
              variants={containerVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              className="grid grid-cols-1 md:grid-cols-3 gap-8"
            >
              {highlights.map((highlight, index) => {
                const Icon = highlight.icon
                return (
                  <motion.div
                    key={index}
                    variants={itemVariants}
                    whileHover={{ y: -8 }}
                    className="flex items-center gap-4 p-6 rounded-lg border border-primary hover:border-primary_hover transition-all duration-300 bg-gradient-to-br from-white to-primary/10"
                  >
                    <div className="flex-shrink-0 w-16 h-16 rounded-full bg-primary_hover flex items-center justify-center">
                      <Icon className="w-8 h-8 text-white" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900 text-lg">{highlight.title}</h3>
                      <p className="text-gray-600 text-sm">{highlight.description}</p>
                    </div>
                  </motion.div>
                )
              })}
            </motion.div>
          </div>
        </section>

        {/* Featured Categories Section 1 - (Your existing code) */}
        {/* <section className="bg-[#F6F8F8]">
          <div className=" mx-auto  !overflow-hidden px-4 bg-[#F6F8F8] py-[30px] md:my-[60px] my-[30px] max-w-[1390px]">
            <h2 className="text-black !font-montserrat uppercase text-center text-[20px] md:!text-[24px] font-semibold leading-[24px] !mb-[40px]">{featuredcategoriesListData[0]?.name}</h2>

            <div className="!relative !overflow-hidden mx-auto">
              <Swiper
                modules={[Autoplay, Navigation, Pagination]}
                spaceBetween={15}
                slidesPerView={2}
                autoplay={{ delay: 3000, disableOnInteraction: false }}
                loop={true}
                navigation={{
                  nextEl: '.custom-next1',
                  prevEl: '.custom-prev1',
                  disabledClass: 'swiper-button-disabled',
                }}
                pagination={{
                  el: '.firstpagination1',
                  clickable: true,
                  bulletClass: 'firstpagination-bullet1',
                  bulletActiveClass: 'firstpagination-bullet-active1',
                }}
                breakpoints={{
                  599: { slidesPerView: 2 },
                  600: { slidesPerView: 2 },
                  700: { slidesPerView: 3 },
                  806: { slidesPerView: 3 },
                  892: { slidesPerView: 3 },
                  1200: { slidesPerView: 4 },
                }}
              >
                {featuredcategoriesListData[0]?.products?.map((product: any) => {
                  const images = product.imageurl
                    ? product.imageurl
                      .split(',')
                      .map(
                        (url: any) =>
                          `https://assetsvilva.blr1.cdn.digitaloceanspaces.com/tamiltshirts/₹{url.trim()}`
                      )
                    : [];

                  return (
                    <SwiperSlide key={product.id}>
                      <div>
                        <div className="relative !mb-[16px]">
                          <Link href={`/p/₹{product.seo_url}`}>
                            <div className="relative w-full aspect-[4/5] overflow-hidden rounded-[8px]">
                              <Image
                                fill
                                priority
                                sizes="(max-width: 600px) 50vw, (max-width: 1200px) 33vw, 25vw"
                                className="object-cover object-top transition-opacity duration-300 ease-in-out group-hover:opacity-0"
                                src={images?.[0] || 'https://assetsvilva.blr1.cdn.digitaloceanspaces.com/vilvabusiness/no-image.webp'}
                                alt={product?.name || 'Product'}
                              />
                            </div>
                          </Link>
                        </div>
                        <div>
                          <div className="flex items-center justify-between">
                            <p className="text-black font-montserrat !text-[11px] md:!text-[13px] font-medium leading-[13px] truncate">
                              {product.name}
                            </p>
                            <svg className="cursor-pointer" onClick={async () =>
                              addtowishlist(
                                product,
                                productwishlistData,
                                setproductwishlistData,
                                navigate
                              )
                            }
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="21"
                              viewBox="0 0 20 21"
                              fill={
                                productwishlistData?.includes(
                                  product?.id?.toString()
                                )
                                  ? "#f45440"
                                  : "none"
                              }
                            >
                              <path
                                d="M15.8333 11.9202C17.075 10.7035 18.3333 9.24521 18.3333 7.33687C18.3333 6.1213 17.8504 4.95551 16.9909 4.09597C16.1314 3.23643 14.9656 2.75354 13.75 2.75354C12.2833 2.75354 11.25 3.17021 9.99999 4.42021C8.74999 3.17021 7.71666 2.75354 6.24999 2.75354C5.03441 2.75354 3.86863 3.23643 3.00908 4.09597C2.14954 4.95551 1.66666 6.1213 1.66666 7.33687C1.66666 9.25354 2.91666 10.7119 4.16666 11.9202L9.99999 17.7535L15.8333 11.9202Z"
                                stroke="#676767"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                          <Link href={`/p/₹{product.seo_url}`}>
                            <p className="text-[#676767] font-montserrat !text-[12px] md:!text-[13px] font-medium leading-[15.6px] my-[6px] truncate">
                              {featuredcategoriesListData?.[0]?.name || 'Category'}
                            </p>
                            <div className="flex items-center gap-[4px]">
                              <p className="text-black font-montserrat  !text-[14px] md:!text-[16px] font-medium leading-normal">
                                ₹{product?.sp || 0}
                              </p>
                              <p className="text-[#676767] font-montserrat  !text-[14px] md:!text-[16px] font-medium leading-normal line-through">
                                ₹{product?.mrp || 1}
                              </p>
                              <p className="text-[#25AB20] !text-[12px] md:!text-[14px] font-medium leading-none font-[Montserrat]">
                                {Math.round(
                                  ((parseFloat(product?.mrp || 1) - parseFloat(product?.sp || 0)) /
                                    parseFloat(product?.mrp || 1)) *
                                  100
                                )}
                                % Off
                              </p>
                            </div>
                          </Link>
                        </div>
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
              <div className=" w-full justify-between  z-10 ">
                <button
                  className="custom-prev1 hidden md:!flex !w-[32px] z-10 !h-[32px] p-[6px] justify-center items-center absolute top-1/2 left-2 flex-shrink-0 rounded-[16px] bg-white shadow-[0px_17px_5px_rgba(0,0,0,0),0px_11px_4px_rgba(0,0,0,0.01),0px_6px_4px_rgba(0,0,0,0.05),0px_3px_3px_rgba(0,0,0,0.09),0px_1px_2px_rgba(0,0,0,0.10)]"
                  aria-label="Previous slide"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M12.5 15L7.5 10L12.5 5"
                      stroke="black"
                      strokeWidth="1.25"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
                <button
                  className="custom-next1  absolute top-1/2 right-2  z-10 hidden md:!flex !w-[32px] !h-[32px] p-[6px] justify-center items-center flex-shrink-0 rounded-[16px] bg-white shadow-[0px_17px_5px_rgba(0,0,0,0),0px_11px_4px_rgba(0,0,0,0.01),0px_6px_4px_rgba(0,0,0,0.05),0px_3px_3px_rgba(0,0,0,0.09),0px_1px_2px_rgba(0,0,0,0.10)]"
                  aria-label="Next slide"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M7.5 15L12.5 10L7.5 5"
                      stroke="black"
                      strokeWidth="1.25"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>

              <div className="firstpagination1 flex justify-center mt-4 md:hidden"></div>
            </div>
          </div>
        </section> */}

        <section className="py-10 md:py-28 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* Header */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              className="flex items-center justify-between mb-12"
            >
              <div>
                <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-2">
                  New Products
                </h2>
                <div className="w-[200px] h-1 bg-gradient-to-r from-primary to-white" />
              </div>

              <div className="hidden md:flex gap-2">
                <button
                  onClick={() => swiperRef?.slidePrev()}
                  className="p-2 rounded-full border border-primary text-primary hover:bg-green-50 transition"
                >
                  ←
                </button>
                <button
                  onClick={() => swiperRef?.slideNext()}
                  className="p-2 rounded-full border border-primary text-primary hover:bg-green-50 transition"
                >
                  →
                </button>
              </div>
            </motion.div>

            {/* Product Slider */}
            <Swiper
              modules={[Navigation]}
              onSwiper={(swiper) => setSwiperRef(swiper)}
              spaceBetween={20}
              slidesPerView={1}
              breakpoints={{
                640: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
              }}
              className="relative"
            >
              {products.map((product, index) => (
                <SwiperSlide key={product.id}>
                  <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.2 }}
                    transition={{ delay: index * 0.1 }}
                    className="relative group"
                  >
                    {/* Product Card */}
                    <div className="bg-gray-50 rounded-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
                      {/* Image */}
                      <Link href="/products/premium-teaproducts-online">
                        <div className="relative h-80 overflow-hidden">
                          <img
                            src={product.image || "/placeholder.svg"}
                            alt={product.name}
                            className="w-full h-full  group-hover:scale-110 transition-transform duration-300"
                          />

                          {/* Discount Badge */}
                          {product.discount && (
                            <div className="absolute top-4 left-4 bg-green-600 text-white px-3 py-1 rounded-full text-sm font-bold">
                              {product.discount}
                            </div>
                          )}

                          {/* Add to Cart Button */}
                          <motion.button
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            className="absolute bottom-4 right-4 bg-white text-primary p-3 rounded-full shadow-md hover:bg-primary hover:text-white transition-all opacity-0 group-hover:opacity-100"
                          >
                            <ShoppingCart size={20} />
                          </motion.button>
                        </div>

                        {/* Product Info */}
                        <div className="p-6">
                          <h3 className="text-lg font-semibold text-gray-900 mb-3">
                            {product.name}
                          </h3>

                          <div className="flex items-center gap-3 mb-4">
                            <span className="text-2xl font-bold text-primary">
                              {product.price}
                            </span>
                            <span className="text-sm text-gray-500 line-through">
                              {product.originalPrice}
                            </span>
                          </div>

                          <div className="flex gap-1 mb-4">
                            {[...Array(5)].map((_, i) => (
                              <span key={i} className="text-yellow-400">
                                ★
                              </span>
                            ))}
                          </div>
                        </div>
                      </Link>
                    </div>
                  </motion.div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </section>



        {/* PROMO BANNER SECTION */}
        <section className="py-8 md:py-20 bg-white ">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true, amount: 0.2 }}
              className="relative rounded-lg overflow-hidden h-full "
            >
              {/* Background Image */}
              <div className="absolute md:bottom-0 inset-0 ">
                <video
                  src="/assets/images/vid.mp4"
                  autoPlay
                  loop
                  muted
                  playsInline
                  className="w-full h-full object-cover"
                />
                <div className="absolute md:bottom-0 inset-0 bg-black/30" />
              </div>

              {/* Content */}
              <div className="relative h-full flex items-center px-8 md:px-16 py-[24px]">
                <motion.div
                  initial={{ opacity: 0, x: -30 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, amount: 0.2 }}
                  transition={{ delay: 0.1 }}
                  className="max-w-lg"
                >
                  <p className="text-white/80 text-sm md:text-base mb-2">Special Offer</p>
                  <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
                    Tea Shop Starter <br />
                    Equipment Kit
                  </h2>
                  <p className="text-white/90 text-base mb-6 max-w-md">
                    Get everything you need to open your tea café in one kit — kettles, tea brewers, storage jars,
                    counters, and serving tools. Limited time discounted launch price for new shop owners.
                  </p>

                  <motion.div whileHover={{ x: 5 }}>
                    <Link
                      href="#"
                      className="inline-block border-2 border-white text-white px-8 py-3 font-semibold hover:bg-white hover:text-gray-900 transition-all duration-300"
                    >
                      Explore the Shop →
                    </Link>
                  </motion.div>
                </motion.div>
              </div>
            </motion.div>
          </div>
        </section>

        <section className="py-20 md:py-28 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* Header */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              className="mb-12"
            >
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-2">Popular Categories</h2>
              <div className="w-[200px] h-1 bg-gradient-to-r from-primary to-white" />
            </motion.div>

            {/* Categories Grid */}
            <motion.div
              variants={containerVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6"
            >
              {categories.map((category) => (
                <motion.div key={category.id} variants={itemVariants} whileHover={{ scale: 1.05 }} className="group">
                  <Link href="/products/premium-teaproducts-online">
                    <div className="relative overflow-hidden rounded-lg h-80 mb-4">
                      <img
                        src={category.image || "/placeholder.svg"}
                        alt={category.name}
                        className="w-full h-full object-cover group-hover:scale-125 transition-transform duration-500"
                      />
                      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300" />
                    </div>
                    <div className="bg-green-600 text-white py-2 px-4 rounded mb-3 inline-block text-xs font-bold">
                      {category.discount}
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">{category.name}</h3>
                    <div className="flex items-center justify-between">
                      <div className="flex gap-2 items-center">
                        <span className="text-xl font-bold text-primary">{category.price}</span>
                        <span className="text-sm text-gray-500 line-through">{category.originalPrice}</span>
                      </div>
                      <button className="bg-primary text-white p-2 rounded hover:bg-green-800 transition">
                        <ShoppingCart size={18} />
                      </button>
                    </div>
                  </Link>
                </motion.div>
              ))}
            </motion.div>
          </div>
        </section>

        {/* <section className="py-20 md:py-28 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              className="mb-12"
            >
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-2">Popular Categories</h2>
              <div className="w-16 h-1 bg-gradient-to-r from-primary to-green-500" />
            </motion.div>

            <motion.div
              variants={containerVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6"
            >
              {mainCategories.slice(0, 4).map((category) => (
                <motion.div key={category.id} variants={itemVariants} whileHover={{ scale: 1.05 }} className="group">
                  <div className="relative overflow-hidden rounded-lg h-80 mb-4">
                    <img
                      src={`https://assetsvilva.blr1.cdn.digitaloceanspaces.com/tamiltshirts/₹{category.banner}` || "/placeholder.svg"}
                      alt={category.name}
                      className="w-full h-full object-cover group-hover:scale-125 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300" />
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">{category.name}</h3>
                  <Link href={`/products/₹{category.seo_url}`} className="text-primary font-semibold hover:underline">
                    Explore →
                  </Link>
                </motion.div>
              ))}
            </motion.div>
          </div>
        </section> */}

        <section className="py-10 md:py-28 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* Header */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              className="mb-12"
            >
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-2">From Our Blog</h2>
              <div className="w-[200px] h-1 bg-gradient-to-r from-primary to-white" />
            </motion.div>

            {/* Blog Grid */}
            <motion.div
              variants={containerVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              className="grid grid-cols-1 md:grid-cols-3 gap-8"
            >
              {blogs.map((blog) => (
                <motion.div key={blog.id} variants={itemVariants} whileHover={{ y: -10 }} className="group cursor-pointer">
                  <div className="relative overflow-hidden rounded-lg h-72 mb-6">
                    <img
                      src={blog.image || "/placeholder.svg"}
                      alt={blog.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                  </div>
                  <p className="text-sm text-gray-500 mb-2">{blog.date}</p>
                  <h3 className="text-xl font-semibold text-gray-900 mb-3 group-hover:text-primary transition">
                    {blog.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed mb-4">{blog.excerpt}</p>
                  <Link
                    href="#"
                    className="inline-flex items-center text-primary font-semibold hover:gap-2 transition-all"
                  >
                    Read More <ArrowRight size={16} className="ml-2" />
                  </Link>
                </motion.div>
              ))}
            </motion.div>
          </div>
        </section>


        {/* <section className="py-20 md:py-28 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              className="mb-12"
            >
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-2">From Our Blog</h2>
              <div className="w-16 h-1 bg-gradient-to-r from-primary to-green-500" />
            </motion.div>

            <motion.div
              variants={containerVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              className="grid grid-cols-1 md:grid-cols-3 gap-8"
            >
              {blogData?.slice(0, 3).map((blog: any) => {
                const images = blog.image
                  ? blog.image
                    .split(',')
                    .map(
                      (url: any) =>
                        `https://assetsvilva.blr1.cdn.digitaloceanspaces.com/ecomsaas/redisapi/hq2Tam171123/₹{url.trim()}`
                    )
                  : `https://assetsvilva.blr1.cdn.digitaloceanspaces.com/ecomsaas/redisapi/hq2Tam171123/blogs/1747992094_68303e1e19ae3.webp`;

                return (
                  <motion.div key={blog.id} variants={itemVariants} whileHover={{ y: -10 }} className="group cursor-pointer">
                    <Link href={`/blog/₹{blog.slug}`}>
                      <div className="relative overflow-hidden rounded-lg h-72 mb-6">
                        <img
                          src={images || "/placeholder.svg"}
                          alt={blog.title}
                          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                        />
                      </div>
                      <h3 className="text-xl font-semibold text-gray-900 mb-3 group-hover:text-primary transition">
                        {blog.title}
                      </h3>
                      <p className="text-gray-600 text-sm leading-relaxed mb-4">
                        <span
                          dangerouslySetInnerHTML={{
                            __html:
                              (blog.short_content
                                ? blog.short_content.slice(0, 100) +
                                (blog.short_content.length > 100 ? "..." : "")
                                : "")
                          }}
                        />
                      </p>
                      <div className="inline-flex items-center text-primary font-semibold hover:gap-2 transition-all">
                        Read More <ArrowRight size={16} className="ml-2" />
                      </div>
                    </Link>
                  </motion.div>
                );
              })}
            </motion.div>
          </div>
        </section> */}

        {/* NEWSLETTER SECTION */}
        <section className="py-20 md:py-28 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
              {/* Left Image */}
              <motion.div
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.6 }}
                className="relative h-96 md:h-full md:min-h-96"
              >
                <video
                  src="/assets/images/sub.mp4"
                  autoPlay
                  loop
                  muted
                  playsInline
                  className="w-full h-full object-cover"
                />
              </motion.div>

              {/* Right Content */}
              <motion.div
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.6 }}
                className="space-y-6"
              >
                <div>
                  <p className="text-primary text-sm font-semibold uppercase mb-2">Subscribe</p>
                  <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
                    Join & Save — Exclusive Offers for Tea Shop Owners
                  </h2>
                </div>

                <p className="text-gray-600 text-base leading-relaxed">
                  Get early access to discounts, bundle deals, and industry insights. Whether you're starting a café
                  or upgrading your equipment, our emails help you save more and grow faster.
                </p>


                {/* Email Form */}
                <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 pt-4">
                  <div className="flex-1 relative">
                    <Mail className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                    <input
                      type="email"
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-primary focus:ring-2 focus:ring-green-100 transition"
                    />
                  </div>
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    type="submit"
                    className="bg-primary text-white px-6 py-3 rounded-lg font-semibold hover:bg-primary_hover transition-colors flex items-center justify-center gap-2"
                  >
                    Subscribe
                    <Send size={18} />
                  </motion.button>
                </form>

                {submitted && (
                  <motion.p
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    className="text-primary font-semibold text-sm"
                  >
                    ✓ Thank you for subscribing!
                  </motion.p>
                )}
              </motion.div>
            </div>
          </div>
        </section>

      </div>
    </>
  );
};

export default Homepage;
